import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class Personel {
  id: string;
  creatorId: number;
  createdAt: string;
  name: string;
  tc: string;
  status: number;
  regionId: number;
  supplierId: string;
  userId: number;
  type: string;
  education: number;
}

export class Gate {
  id: string;
  creatorId: number;
  createdAt: string;
  name: string;
  regionId: number;
  status: number;
}

export class Mission {
  id: string;
  creatorId: number;
  createdAt: string;
  name: string;
  status: number;
}

export class IPersonelLog {
  id: string;
  creatorId: number;
  createdAt: string;
  status: number;
  personelId: string;
  personel: Personel;
  gate: Gate;
  mission: Mission;
  gateId: string;
  workday: number;
  startDate: string;
  endDate: string;
}

export class IPersonelLogResponse {
  @Type(() => IPersonelLog)
  result: IPersonelLog;
}

export class IPersonelLogListResponse extends IPagination {
  @Type(() => IPersonelLog)
  results: IPersonelLog[];
}

export class IPersonelLogQueryDto extends IQueryPaginationDto {
  personelId?: string;
  gateId?: string;
  dateCreatedStart?: string;
  dateCreatedEnd?: string;
  status?: number;
  supplierId?: string;
  regionId?: number;
  gorevId?: string;
}

export class IPersonelLogPostDto {
  personelId: string;
  gateId: string;
  workday: number;
}

export class IPersonelLogEntryPostDto {
  identityNumber: string;
  gateId: string;
}

export class IPersonelLogExitPostDto {
  identityNumber: string;
  gateId: string;
}
